/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";

const MESSAGES = defineMessages({
  newEmailText: {
    id: "newEmail.text",
    defaultMessage: "New Email Address",
  },
  newEmailError: {
    id: "newEmail.error",
    defaultMessage: "This email is incorrect",
  },
});

export default MESSAGES;